import RoomsContent from './Content'
import * as React from 'react'
import Modal from 'LuxKit/Modal/Modal'
import { useCallback } from 'react'
import useModalElementContext from 'hooks/Modal/useModalElementContext'
import { useMultiRoomSelectionSearchBar } from 'businessTraveller/hooks/useMultiRoomSelection'

interface Props {
  onApply: () => void
}

export default function RoomsModal({ onApply }: Props) {
  const modalElementContext = useModalElementContext()

  // Must read state from hook directly (not props) because modal is rendered outside the React tree
  // on file multi-room-hotels/searchBar/Mobile.tsx
  // so props passed via showModal() would be stale and not update when state changes.
  const {
    occupancies,
    totalTravellers,
    onRoomCountChange,
  } = useMultiRoomSelectionSearchBar()

  const dismiss = useCallback(() => {
    modalElementContext.resolve()
    onApply()
  }, [modalElementContext, onApply])

  return <Modal
    mode="drawer"
    title="How many rooms?"
    primaryActionText="Continue"
    onPrimaryActionClick={dismiss}
  >
    <RoomsContent size="large" rooms={occupancies} onRoomCountChange={onRoomCountChange} travellerCount={totalTravellers} />
  </Modal>
}
